export var Urls = {
    GetMe: "me",
    DoesUserExist: "me/DoesUserExist",
    GetMyAccessibleDepartments: "me/getMyAccessibleDepartments",
    ChangePassword: "me/changePassword",
    SwitchMe: "me/switchRole",
};
